<template lang="html">
  <div class="welfare">
    <div class="titleIcon">
      <img src="../../assets/image/welfare/title.png" alt="">
    </div>
    <div class="iconNo2">
      打造垂直化数字内容生态社区
    </div>

    <div class="iconNo3">
      <img src="../../assets/image/welfare/iconNo3.png" alt="">
    </div>
    <div class="tabHeader">
      <ul class="tabMod">
        <li class="tabChild" @click="cur = 0" :class="{activeNo1:cur == 0}">
          企业&高校号
        </li>
        <li class="tabChild" @click="cur=1" :class="{activeNo2:cur == 1}">
          专家号
        </li>
      </ul>
    </div>
    <div class="tabContent">
      <div class="conChild" v-show="cur == 0">
        <div class="firstMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">品牌营销？无数字化营销平台、方式</p>
          <div class="conNo1">
            <p class="conH1">认证电巢号</p>
            <p class="conH2">提供数字化营销平台、方式</p>
            <div class="welfareCon">
              <p>
                <img src="../../assets/image/welfare/iconNo5.png" alt="">
                <span>自定义首页</span>
              </p>
              <p>
                <img src="../../assets/image/welfare/iconNo6.png" alt="">
                <span>专属标识</span>
              </p>
              <p>
                <img src="../../assets/image/welfare/iconNo7.png" alt="">
                <span>私域留言板</span>
              </p>
            </div>
          </div>
          <div class="elseWelfareCon">
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo8.png" alt="">
              <p class="conH3">发布活动</p>
              <p class="conH4">报名及投<br>票活动</p>
            </div>
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo9.png" alt="">
              <p class="conH3">发起直播</p>
              <p class="conH4">官方联合<br>直播</p>
            </div>
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo10.png" alt="">
              <p class="conH3">产品测评</p>
              <p class="conH4">视频/图<br>文测评</p>
            </div>
          </div>
        </div>
        <div class="secondMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">企业找不到上下游企业？无精力对接小单个人单？</p>
          <div class="secondCon">
            <div class="secondChildMod" style="margin-bottom: 15px">
              <img src="../../assets/image/welfare/iconNo11.png" alt="">
              <div>
                <p class="secondChildTitle">企业展厅</p>
                <p class="secondChildText">认证企业一览展示，快速了解企业资质详情</p>
              </div>
            </div>
            <div class="secondChildMod">
              <img src="../../assets/image/welfare/iconNo12.png" alt="">
              <div>
                <p class="secondChildTitle">商品橱窗</p>
                <p class="secondChildText">产品从测评到交易，一站式全流程销售</p>
              </div>
            </div>
          </div>
        </div>
        <div class="thirdtMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">缺乏目标用户画像和精准客户获取？</p>
          <div class="secondCon">
            <div class="secondChildMod" style="margin-bottom: 15px">
              <img src="../../assets/image/welfare/iconNo13.png" alt="">
              <div>
                <p class="secondChildTitle">运营数据</p>
                <p class="secondChildText">提供图示化全方位运营数据</p>
              </div>
            </div>
            <div class="secondChildMod">
              <img src="../../assets/image/welfare/iconNo14.png" alt="">
              <div>
                <p class="secondChildTitle">用户画像</p>
                <p class="secondChildText">助力企业用户画像，最终对标到最真实的客户</p>
              </div>
            </div>
          </div>
        </div>
        <div class="firstMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">企业人才招聘、培养及晋升的局限性？学生缺少实战经验，优秀毕业生无直推渠道？</p>
          <ul>
            <li>
              <div class="describe">
                <span></span>
                <p>企业员工培训</p>
              </div>
              <p class="describeCon">助力企业定期对员工进行培养、培训，将更高的知识转化成生产力是推动企业发展的核心点</p>
            </li>
            <li>
              <div class="describe">
                <span></span>
                <p>学校专业集训</p>
              </div>
              <p class="describeCon">大厂认证老师为该专业的学生进行系统定制的知识、素养、项目实战等开班集训</p>
            </li>
          </ul>
          <div class="secondCon">
            <div class="secondChildMod" style="margin-bottom: 15px">
              <img src="../../assets/image/welfare/iconNo15.png" alt="">
              <div>
                <p class="secondChildTitle">企业招聘</p>
                <p class="secondChildText">精准推送企业的招聘信息</p>
              </div>
            </div>
            <div class="secondChildMod">
              <img src="../../assets/image/welfare/iconNo16.png" alt="">
              <div>
                <p class="secondChildTitle">实习直推</p>
                <p class="secondChildText">优秀毕业生精准推送给诉求企业</p>
              </div>
            </div>
          </div>
        </div>

        <div class="footerMod">
          <p class="footerDescribe">你可以这样联系我</p>
          <p class="footerDescribeCon">有任何疑问，可以添加企业微信咨询我们呀~</p>
          <img src="../../assets/image/welfare/qrCode.png" alt="" class="footerImg">
        </div>
      </div>
      <div class="conChild" v-show="cur == 1">
        <div class="firstMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">知名度局限性，无法充分实现自我价值</p>
          <div class="conNo1">
            <p class="conH1">认证电巢号</p>
            <p class="conH2">提供数字化营销平台、方式</p>
            <div class="welfareCon">
              <p>
                <img src="../../assets/image/welfare/iconNo5.png" alt="">
                <span>自定义首页</span>
              </p>
              <p>
                <img src="../../assets/image/welfare/iconNo6.png" alt="">
                <span>专属标识</span>
              </p>
              <p>
                <img src="../../assets/image/welfare/iconNo7.png" alt="">
                <span>私域留言板</span>
              </p>
            </div>
          </div>
          <div class="elseWelfareCon">
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo8.png" alt="">
              <p class="conH3">发布活动</p>
              <p class="conH4">报名及投<br>票活动</p>
            </div>
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo9.png" alt="">
              <p class="conH3">发起直播</p>
              <p class="conH4">官方联合<br>直播</p>
            </div>
            <div class="elseWelfareConChild">
              <img src="../../assets/image/welfare/iconNo17.png" alt="">
              <p class="conH3">高质量内容</p>
              <p class="conH4">视频/图文</p>
            </div>
          </div>
        </div>
        <div class="secondMod">
          <img src="../../assets/image/welfare/iconNo4.png" alt="" class="elseIcon">
          <p class="cTitle">电子圈知名大咖，如何知识变现？</p>
          <div class="secondCon">
            <div class="secondChildMod" style="margin-bottom: 15px">
              <img src="../../assets/image/welfare/iconNo18.png" alt="">
              <div>
                <p class="secondChildTitle">直播打赏</p>
                <p class="secondChildText">高质量直播分享获取打赏</p>
              </div>
            </div>
            <div class="secondChildMod" style="margin-bottom: 15px">
              <img src="../../assets/image/welfare/iconNo12.png" alt="">
              <div>
                <p class="secondChildTitle">橱窗带货</p>
                <p class="secondChildText">专业讲解为企业带货</p>
              </div>
            </div>
            <div class="secondChildMod">
              <img src="../../assets/image/welfare/iconNo10.png" alt="">
              <div>
                <p class="secondChildTitle">产品测评</p>
                <p class="secondChildText">专业测评获取有偿收益</p>
              </div>
            </div>
          </div>
        </div>

        <div class="footerMod">
          <p class="footerDescribe">你可以这样联系我</p>
          <p class="footerDescribeCon">有任何疑问，可以添加企业微信咨询我们呀~</p>
          <img src="../../assets/image/welfare/qrCode.png" alt="" class="footerImg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WxShare from '@/utils/wxshare'
    import {pagebase} from '@/utils/http'

  export default {
    data() {
      return {
        cur: 0,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.getWx = new WxShare();
        this.bodyInfo();
      },
      bodyInfo(){
        document.title = '认证号权益';
        this.getWx.share({
          title: '电巢认证号权益详情，快来加入吧',
          desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
          link: pagebase + '/#/welfarShare',
          imgUrl: '/static/img/imgNo2.jpg',
        });
      }
    }
  }
</script>

<style lang="css" scoped>
  .welfare {
    background: url('../../assets/image/welfare/back.png');
  }

  .titleIcon {
    box-sizing: border-box;
    padding: 43px 30px 20px 30px;
  }

  .titleIcon img {
    width: 100%;
  }

  .iconNo2 {
    background: url('../../assets/image/welfare/iconNo2.png');
    width: 100%;
    height: 47px;
    background-repeat: no-repeat;
    background-size: 100% 47px;
    font-size: 20px;
    font-weight: 600;
    text-align: right;
    box-sizing: border-box;
    padding-right: 15px;
  }

  .iconNo3 {
    display: flex;
    justify-content: center;
  }

  .iconNo3 img {
    width: 288.5px;
    height: 170.5px;
  }

  .tabHeader {
    width: 100%;
    box-sizing: border-box;
    padding: 0 21px;
  }

  .tabMod {
    width: 100%;
    height: 45px;
    box-sizing: border-box;
    display: flex;
    border-radius: 45px;
    background-color: #077275;
  }

  .tabChild {
    position: relative;
    width: 50%;
    border-radius: 45px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    z-index: 2;
  }

  .activeNo1::after {
    content: '企业&高校号';
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 45px;
    background: linear-gradient(to right, #00F1B4, #01E0E7);
    color: #0B1C3A;
    z-index: 1;
  }

  .activeNo2:after {
    content: '专家号';
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 45px;
    background: linear-gradient(to right, #00F1B4, #01E0E7);
    color: #0B1C3A;
    z-index: 1;
  }

  .tabContent {
    box-sizing: border-box;
    padding: 40px 15px;
  }

  .elseIcon {
    position: absolute;
    top: 0;
    width: 92%;
    height: 14px;
    margin-top: -7px;
  }

  .cTitle {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    color: #00F1B5;
    font-size: 18px;
    font-weight: 600;
    background: linear-gradient(#0C1D3B, #061935);
    margin-top: 8px;
  }

  .firstMod,
  .secondMod,
  .thirdtMod {
    box-sizing: border-box;
    background-color: #07384B;
    padding: 13px;
    position: relative;
    margin-bottom: 40px;
  }

  /* 模块1 */
  .conNo1 {
    box-sizing: border-box;
    padding: 16px;
    margin-top: 15px;
    background: linear-gradient(to right, #00F1B4, #01E0E7);
    border-radius: 10px;
  }

  .conH1 {
    font-size: 16px;
    color: #061834;
    font-weight: 600;
  }

  .conH2 {
    font-size: 14px;
    color: #04585A;
    margin-top: 3px;
  }

  .welfareCon {
    padding: 11px 17px;
    box-sizing: border-box;
    background-color: #07384B;
    border-radius: 10px;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
  }

  .welfareCon p {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .welfareCon img {
    width: 55px;
    height: 55px;
    margin-bottom: 10px;
  }

  .elseWelfareCon {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }

  .elseWelfareConChild {
    box-sizing: border-box;
    width: 30%;
    background: linear-gradient(to right, #00F1B4, #01E0E7);
    border-radius: 10px;
    display: flex;
    padding: 11px 0;
    flex-direction: column;
    align-items: center;
  }

  .elseWelfareConChild img {
    width: 55px;
    height: 55px;
  }

  .conH3 {
    font-weight: 600;
    color: #061834;
    font-size: 16px;
    margin-top: 11px;
    text-align: center;
  }

  .conH4 {
    font-size: 14px;
    color: #04585A;
    margin-top: 11px;
    text-align: center;
  }

  /* 模块2 */
  .secondCon {
    box-sizing: border-box;
    padding: 16px;
    margin-top: 15px;
    background: linear-gradient(to right, #00F1B4, #01E0E7);
    border-radius: 10px;
  }

  .secondChildMod {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 20px 10px;
    background-color: rgba(7, 56, 75, 0.75);
    border-radius: 10px;
  }

  .secondChildMod img {
    width: 55px;
    height: 55px;
    margin-right: 10px;
  }

  .secondChildTitle {
    color: #FFFFFF;
    font-weight: 600;
  }

  .secondChildText {
    font-size: 14px;
    color: #90BEC5;
  }

  .describe {
    display: flex;
    align-items: center;
    color: #FFFFFF;
    font-weight: 600;
    margin-top: 30px;
  }

  .describe span {
    width: 10px;
    height: 10px;
    background: linear-gradient(#00F1B4, #01E0E7);
    margin-right: 10px;
  }

  .describeCon {
    padding-left: 20px;
    margin-top: 5px;
    font-size: 14px;
    color: #90BEC5;
  }

  .footerMod {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footerDescribe {
    margin-top: 10px;
    font-size: 18px;
    color: #FFFFFF;
    font-weight: 600;
  }

  .footerDescribeCon {
    margin-top: 10px;
    font-size: 14px;
    color: #ABC4D9;
  }

  .footerImg {
    margin-top: 28px;
    width: 130px;
    height: 130px;
  }
</style>
